import { TOrderListItem } from '@app/api/orders/orders.service';

export function getOrderTabComponentStatus(
  status: string,
): 'notPayment' | 'onWay' | 'completed' | 'cancel' | 'awaiting' {
  switch (status) {
    case 'not_paid':
      return 'notPayment';
    case 'delivery':
      return 'onWay';
    case 'completed':
      return 'completed';
    case 'canceled':
      return 'cancel';
    case 'awaiting_pickup':
      return 'awaiting';
    case 'awaiting_send_digital_card':
      return 'awaiting';
    default:
      return 'onWay';
  }
}

export function getOrderListItemSum(data: TOrderListItem): number {
  return data.items.reduce((acc, current) => {
    if (current.cardType === 'digital') {
      return acc + current.nominal;
    }
    return acc + current.nominal * current.count;
  }, 0);
}
